// uuid-polyfill.js
import {v4 as uuidv4} from 'uuid';

const cryptoObject = window.crypto || {};

if (!cryptoObject.randomUUID) {
	cryptoObject.randomUUID = () => uuidv4();
}

if (!window.crypto) {
	Object.defineProperty(window, 'crypto', {
		value: cryptoObject,
		writable: false, // Ensures that the object is not writable
		configurable: false, // Ensures that the property cannot be deleted
		enumerable: true,
	});
}
